var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LinkButton',{staticClass:"register-button",attrs:{"mode":"flat","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.openModal($event)}}},[_vm._v("Zugang anfordern")])}
var staticRenderFns = []

export { render, staticRenderFns }